const Collections={
    "Grocceries":[
        {
            product:"Ashirvaad Whoole Wheat per 1 kg",
            image:"/images/Grocceries/ashirvaadwholewheat.jpg",
            price:"175"
        },
        {
            product:"Brinjal Black big 500 gm",
            image:"/images/Grocceries/brinjalblackbig500gm.jpg",
            price:"45"
        },
        {
            product:"Everest Shahi Biriyani ",
            image:"/images/Grocceries/everestshahibiriyani.jpg",
            price:"155"
        },
        {
            product:"Good Life Sugar  ",
            image:"/images/Grocceries/goodlifesugar.jpg",
            price:"25"
        },
        {
            product:"India Gate basmati rice 1 kg  ",
            image:"/images/Grocceries/indiagatesuperbasmatirice1kg.jpg",
            price:"120"
        },
        {
            product:"Lauki 1 kg  ",
            image:"/images/Grocceries/lauki.jpg",
            price:"44"
        },
        {
            product:"Onion 5 kg ",
            image:"/images/Grocceries/onion5kg.jpg",
            price:"125"
        },
        {
            product:"Papaya 500 gm ",
            image:"/images/Grocceries/papaya.jpg",
            price:"42"
        },
        {
            product:"Patato per kg ",
            image:"/images/Grocceries/patatoperkg.jpg",
            price:"24"
        },
        {
            product:"Saffola 1 kg ",
            image:"/images/Grocceries/saffola.jpg",
            price:"115"
        },
        {
            product:"Coconut Cling Wrapped ",
            image:"/images/Grocceries/tendercoconutclingwrapped.jpg",
            price:"40"
        },
        {
            product:"Tomato 500 gm ",
            image:"/images/Grocceries/tomato500gm.jpg",
            price:"20"
        },
        {
            product:"Ashirvaad Whoole Wheat per 1 kg",
            image:"/images/Grocceries/ashirvaadwholewheat.jpg",
            price:"175"
        },
        {
            product:"Brinjal Black big 500 gm",
            image:"/images/Grocceries/brinjalblackbig500gm.jpg",
            price:"45"
        },
        {
            product:"Everest Shahi Biriyani ",
            image:"/images/Grocceries/everestshahibiriyani.jpg",
            price:"155"
        },
        {
            product:"Good Life Sugar  ",
            image:"/images/Grocceries/goodlifesugar.jpg",
            price:"25"
        },
        {
            product:"India Gate basmati rice 1 kg  ",
            image:"/images/Grocceries/indiagatesuperbasmatirice1kg.jpg",
            price:"120"
        },

    ],
   HomeKitchen:[
    {
        product:"Anjali 4-in-1 Scraper ",
        image:"/images/Home-Kitchen/anjali4-in-1scraper.jpg",
        price:"120"
    },
    {
        product:"Blue White 2 fold Umbrella",
        image:"/images/Home-Kitchen/bluewhite2foldumbrella.jpg",
        price:"220"
    },
    {
        product:"Click n Seal BPA free Plastic Air Tight Storage",
        image:"/images/Home-Kitchen/clicknsealbpafreeplasticairtightstorage.jpg",
        price:"230"
    },
    {
        product:"Everready Red 1050 carbon zinc batteries",
        image:"/images/Home-Kitchen/evereadyred1050carbonzincbatteries.jpg",
        price:"45"
    },
    {
        product:"Hawkins Stainless Steel induction Pressure",
        image:"/images/Home-Kitchen/hawkinsstainlessteelinductionpressure.jpg",
        price:"210"
    },
    {
        product:"Milton Thermosteel Bullet flask with flip lid 750 ml",
        image:"/images/Home-Kitchen/miltonthermosteelbulletflaskwithfliplid750ml.jpg",
        price:"110"
    },
    {
        product:"Spartan black grey mosquito resistant",
        image:"/images/Home-Kitchen/spartanblackgreymosquitoresistant.jpg",
        price:"155"
    },
    {
        product:"Steel Dessert Spoon 6 pcs",
        image:"/images/Home-Kitchen/steeldessertspoon6pc.jpg",
        price:"50"
    },
    {
        product:"Steel Spoon 15 cm 6 pcs",
        image:"/images/Home-Kitchen/steeltrespoon15cm6pcs.jpg",
        price:"50"
    },
    {
        product:"Blue White 2 fold Umbrella",
        image:"/images/Home-Kitchen/bluewhite2foldumbrella.jpg",
        price:"220"
    },
    {
        product:"Click n Seal BPA free Plastic Air Tight Storage",
        image:"/images/Home-Kitchen/clicknsealbpafreeplasticairtightstorage.jpg",
        price:"230"
    },
    {
        product:"Everready Red 1050 carbon zinc batteries",
        image:"/images/Home-Kitchen/evereadyred1050carbonzincbatteries.jpg",
        price:"45"
    },
    {
        product:"Hawkins Stainless Steel induction Pressure",
        image:"/images/Home-Kitchen/hawkinsstainlessteelinductionpressure.jpg",
        price:"210"
    },
    {
        product:"Milton Thermosteel Bullet flask with flip lid 750 ml",
        image:"/images/Home-Kitchen/miltonthermosteelbulletflaskwithfliplid750ml.jpg",
        price:"110"
    },
   ],
   Fashion:[
    {
        product:"Bride Sports Shoes",
        image:"/images/Fashion/bridesportsshoes.jpg",
        price:"210"
    },
    {
        product:"Buy that trend Women Multicolor Solid Cotton",
        image:"/images/Fashion/buythattrendzwomenmulticolorsolidcotton.jpg",
        price:"270"
    },
    {
        product:"Digmart Boys Multicolored Designer",
        image:"/images/Fashion/digmartboysmulticoloreddesigner.jpg",
        price:"320"
    },
    {
        product:"Dsk Studio Women Green all over Print Crepe Kurta",
        image:"/images/Fashion/dskstudiowomengreenalloverprintcrepekurta.jpg",
        price:"431"
    },
    {
        product:"Fabcartz Banarasi Lehenga Choli Dupatta",
        image:"/images/Fashion/fabcartzbanarasilehengacholidupatta.jpg",
        price:"565"
    },
    {
        product:"Foot Soulprime Women's sandals",
        image:"/images/Fashion/footsoulprimawomen'ssandals.jpg",
        price:"435"
    },
    {
        product:"For the Beautiful You women blue Clutch",
        image:"/images/Fashion/forthebeautifulyouwomenblueclutch.jpg",
        price:"735"
    },
    {
        product:"Sapatos Women Peach Sandals",
        image:"/images/Fashion/sapatoswomenpeachsandals.jpg",
        price:"472"
    },
    {
        product:"Smartness Men Black Print Cotton Blend Single",
        image:"/images/Fashion/smartnessmenblackprintedcottonblendsingle.jpg",
        price:"592"
    },
    {
        product:"Tees World men black regular fit",
        image:"/images/Fashion/teesworldwomenblackregularfit.jpg",
        price:"543"
    },
    {
        product:"Try This men blue striped cotton T-shirt",
        image:"/images/Fashion/trythismenbluestripedcottont-shirt.jpg",
        price:"343"
    },
    {
        product:"Try This men blue Polo Neck cotton T-shirt",
        image:"/images/Fashion/trythismenpoloneckcottont-shirt.jpg",
        price:"741"
    },
    {
        product:"Unidetd Women Maroon Abstract Rayon Kurta",
        image:"/images/Fashion/unidetdwomenmaroonabstractrayonkurta.jpg",
        price:"1285"
    },
   ]
}

export default Collections;